import { apiBasic, apiGet } from "./requests";

export const getAttributes = () => {
  let path = "items/";
  return apiGet(path);
};

export const createAttribute = (payload) => {
  let path = "item/";
  return apiBasic(payload, path, "post");
};

export const updateAttribute = (id, payload) => {
  let path = `item/${id}/`;
  return apiBasic(payload, path, "patch");
};

export const updateAsociationAttribute = (id, payload, itemGroupId) => {
  let path = `item/${id}/group/${itemGroupId}`;
  return apiBasic(payload, path, "patch");
};

export const getAttributeGroups = () => {
  let path = "item-groups/";
  return apiGet(path);
};

export const getAttributeFromGroup = (itemGroupId) => {
  let path = `items/group/${itemGroupId}`;
  return apiGet(path);
};

export const createAttributeGroup = (payload) => {
  let path = "item-group/";
  return apiBasic(payload, path, "post");
};

export const updateAttributeGroup = (id, payload) => {
  let path = `item-group/${id}`;
  return apiBasic(payload, path, "patch");
};

export const deleteAttributeGroup = (id) => {
  let path = `item-group/${id}/`;
  return apiBasic({}, path, "delete");
};

export const toggleAttributes = (categoryId, productId) => {
  let path = `items/${categoryId}/toogle`;
  return apiBasic({ productId }, path);
};

export const deleteItems = (itemGroupId, payload) => {
  let path = `items/delete-batch/item-group/${itemGroupId}/`;
  return apiBasic(payload, path, "delete");
};
